import { render, staticRenderFns } from "./MCase.vue?vue&type=template&id=34743904&scoped=true"
import script from "./MCase.vue?vue&type=script&lang=js"
export * from "./MCase.vue?vue&type=script&lang=js"
import style0 from "./MCase.vue?vue&type=style&index=0&id=34743904&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34743904",
  null
  
)

export default component.exports